
  import { computed, defineComponent, Ref } from 'vue';
  import { useStore } from 'effector-vue/composition';
  import Info from '@/components/Info.vue';
  import Header from '@/components/header/Header.vue';
  import SignUp from '@/components/SignUp.vue';
  import ActiveCall from '@/components/calls/ActiveCall.vue';
  import IncomingCall from '@/components/IncomingCall.vue';
  import Dialing from '@/components/Dialing.vue';
  import Call from '@/components/Call.vue';
  import Settings from '@/components/ Settings.vue';
  import { $currentComponent } from '@/store/components/index';
  import { $settings } from '@/store/settings/index';
  import { activeCalls, incomingCalls } from '@/store/calls/index';
  import VideoCall from '@/components/VideoCall.vue';
  import { useCallComponentName } from '@/hooks/callComponentName';
  import NotificationBlock from '@/components/NotificationBlock.vue';
  import { $showNotification } from '@/store/notification';
  import appConfig from '@/config';
  import CallEnded from '@/components/CallEnded.vue';
  interface ContentClasses {
    height: string;
    overflowY: string;
  }

  const __default__ = defineComponent({
    name: 'WebPhoneShell',
    components: {
      NotificationBlock,
      VideoCall,
      Settings,
      Call,
      Dialing,
      IncomingCall,
      ActiveCall,
      Header,
      Info,
      SignUp,
      CallEnded,
    },
    setup() {
      const settings = useStore($settings);
      const currentComponentStore = useStore($currentComponent);
      const incoming = useStore(incomingCalls);
      const callsStore = useStore(activeCalls);
      const showNotification = useStore($showNotification);
      const webPhoneClasses = computed(() => ({
        popup: callsStore.value.length > 0,
        maximize: settings.value.maximize,
        collapsed: settings.value.minimize,
        notification: showNotification.value,
      }));
      const contentClasses: Ref<ContentClasses> = computed(() =>
        appConfig.IS_CUSTOMIZE
          ? {
              height: 'fit-content',
              overflowY: 'auto',
            }
          : {
              height: '624px',
              overflowY: 'hidden',
            }
      );
      useCallComponentName();

      return {
        settings,
        currentComponentStore,
        callsStore,
        incoming,
        webPhoneClasses,
        contentClasses,
      };
    },
  });

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "3c804c0a": (_ctx.contentClasses.height),
  "304e397a": (_ctx.contentClasses.overflowY)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__